import { Button, ButtonsGroup, InputText, Toggle } from "#/atoms";
import { FC, memo, useCallback, useEffect } from "react";
import { useInput, useToggle } from "@/hooks";

import { DESKTOP_SPACING } from "@/theme";
import { InputHookProps } from "@/hooks/useInput";
import { Modal } from "#/molecules";
import { StyledUserModal } from "./User.styled";
import { UserModalProps } from "./User.interface";
import { getBoleanFromYesOrNo } from "@/helpers";

const User: FC<UserModalProps> = ({ onClose, onSubmit, type = 'create', user, userId }) => {
  const active = useToggle('active', user?.active ?? true);
  const admin = useToggle('admin',  user?.admin);
  const email = useInput(user?.email);
  const firstName = useInput(user?.firstName);
  const lastName = useInput(user?.lastName);
  const login = useInput(user?.login);
  const inOffice = useToggle('inOffice', user?.inOffice);
  const password = useInput();
  const confirmPassword = useInput();

  const validate = useCallback(() => {
    let isValid = true;

    if (!login.value) {
      isValid = false;
      login.setError('Login is missing.');
    } else {
      login.setError(null);
    }

    if (!firstName.value) {
      isValid = false;
      firstName.setError('First name is missing.');
    } else {
      firstName.setError(null);
    }

    if (!lastName.value) {
      isValid = false;
      lastName.setError('Last name is missing.');
    } else {
      lastName.setError(null);
    }

    if (!email.value) {
      isValid = false;
      email.setError('Email is incorrect.');
    } else {
      email.setError(null);
    }

    if (password.value?.length < 6) {
      isValid = false;
      password.setError('Password is too short.');
    } else {
      password.setError(null);
    }

    if (confirmPassword.value?.length < 6) {
      isValid = false;
      confirmPassword.setError('Password is too short.');
    } else {
      confirmPassword.setError(null);
    }

    if (password.value !== confirmPassword.value) {
      isValid = false;
      confirmPassword.setError('Passwords do not match.');
    } else {
      confirmPassword.setError(null);
    }

    return isValid;
  }, [active, admin, confirmPassword, email, firstName, inOffice, lastName, login, password]);
  
    const onChangeValue = (e : React.ChangeEvent<HTMLInputElement>, input: InputHookProps) => {
      input.onChange(e);

      //validate();
    }

  const handleCreate = useCallback(() => {
    if (!validate()) {
      return;
    }

    onSubmit({
      ConfirmPassword: confirmPassword.value,
      Email: email.value,
      FirstName: firstName.value,
      InOfficeStaff: getBoleanFromYesOrNo(inOffice.value) || false,
      IsActive: getBoleanFromYesOrNo(active.value) || false,
      IsAdmin: getBoleanFromYesOrNo(admin.value) || false,
      LastName: lastName.value,
      Password: password.value,
      UserName: login.value,
    })
  }, [active, admin, confirmPassword, email, firstName, inOffice, lastName, login, password]);

  const title = type === 'create' ? 'Create New User' : 'Edit User';

  return (
    <Modal onClose={onClose} title={title}>
      <StyledUserModal>
        <InputText type="text" label="Login Name" value={login.value} onChange={(e) => onChangeValue(e, login)} errorMessage={login.error || ''} state={login.error ? 'error' : 'idle'} />
        <InputText type="text" label="E-mail Address" value={email.value} onChange={(e) => onChangeValue(e, email)} errorMessage={email.error || ''} state={email.error ? 'error' : 'idle'} />
        <InputText type="text" label="First Name" value={firstName.value} onChange={(e) => onChangeValue(e, firstName)} errorMessage={firstName.error || ''} state={firstName.error ? 'error' : 'idle'} />
        <InputText type="text" label="Last Name" value={lastName.value} onChange={(e) => onChangeValue(e, lastName)} errorMessage={lastName.error || ''} state={lastName.error ? 'error' : 'idle'} />
        <InputText type="password" label="Password" value={password.value} onChange={(e) => onChangeValue(e, password)}  errorMessage={password.error || ''} state={password.error ? 'error' : 'idle'} />
        <InputText type="password" label="Confirm Password" value={confirmPassword.value} onChange={(e) => onChangeValue(e, confirmPassword)} errorMessage={confirmPassword.error || ''} state={confirmPassword.error ? 'error' : 'idle'} />
        <Toggle checked={admin.checked} id={admin.value} label="System Administrator" labelPosition="left" onToggle={admin.onChange} />
        <Toggle checked={inOffice.checked} id={inOffice.value} label="In Office Staff" labelPosition="left" onToggle={inOffice.onChange} />
        <Toggle checked={active.checked} id={active.value} label="Active" labelPosition="left" onToggle={active.onChange} />
        <ButtonsGroup fullWidth margin={`${DESKTOP_SPACING.EL}px 0 0`}>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleCreate}>Save</Button>
        </ButtonsGroup>
      </StyledUserModal>
    </Modal>
  );
};

export default memo(User);
